import { i18n } from '@lingui/core';
import { messages as en } from '../locales/en/messages.js';
import { messages as nb } from '../locales/nb/messages.js';
import { messages as fi } from '../locales/fi/messages.js';
import { messages as da } from '../locales/da/messages.js';

i18n.load({
    en,
    nb,
    fi,
    da,
});

export default i18n;
